import { UserServices } from "../services";
import { useEffect, useState } from "react";

export const useAuthState = () => {
	const [state, setState] = useState<"loading" | "signed" | "unsigned">("loading");

	useEffect(() => {
		UserServices.ready((user) => {
			setState(user ? "signed" : "unsigned");
		});

		const event = UserServices.onAuthStateChanged((user) => {
			setState(user ? "signed" : "unsigned");
		});

		return () => {
			event.stop();
		};
	}, []);

	return state;
};
